import { useState } from "react";
import styles from "./ConsultationList.module.css";

import ListToolbar from "../../Utils/ListToolbar/ListToolbar";

import Pagination from "../../Utils/Pagination/Pagination";
import usePagination from "../../Utils/Hooks/usePagination";

import { useAuth } from "../../../../Context/AuthContext";
import { fetchAllConsultations, deleteConsultation } from "../../../../Api/Backend/Consultation";


function ConsultationList({ onItemClickHandle }) {
    const auth = useAuth();
    // const [consultations, setConsultations] = useState([]);

    const getDefaultDateFrom = () => {
        const date = new Date();
        date.setMonth(date.getMonth() - 3);
        return date.toISOString().split("T")[0];
    };

    const getDefaultDateTo = () => {
        return new Date().toISOString().split("T")[0];
    };

    const [search, setSearch] = useState("");
    const [typeFilter, setTypeFilter] = useState("");
    const [dateFrom, setDateFrom] = useState(getDefaultDateFrom);
    const [dateTo, setDateTo] = useState(getDefaultDateTo);

    const formatDateString = (dateString) => {
        const date = new Date(dateString);
        return date.toISOString().split("T")[0];
    };

    //   const publicationTypes = [...new Set(consultations.map(c => c.publicationType).filter(Boolean))];
    const publicationTypes = ["자비 출판", "반기획 출판", "기획 출판", "아마존 킨들 출판"];
    const { content, page, setPage, totalPages, refresh } = usePagination(
        ({ page, size, onSuccess, onError }) => fetchAllConsultations({ auth, page, size, onSuccess, onError }),
        { pageSize: 10 }
    );

    const filtered = content.filter(c => {
        const matchesSearch = !search ||
            c.name?.toLowerCase().includes(search.toLowerCase()) ||
            c.email?.toLowerCase().includes(search.toLowerCase());

        const matchesType = !typeFilter || c.publicationType === typeFilter;
        const matchesDate = 
            (!dateFrom || formatDateString(c.dateCreated) >= dateFrom) &&
            (!dateTo || formatDateString(c.dateCreated) <= dateTo);

        return matchesSearch && matchesType && matchesDate;
    });

    const handleDelete = async (consultationId) => {
        if (!window.confirm("정말 삭제하시겠습니까?")) return;
        await deleteConsultation({
            auth,
            consultationId,
            onSuccess: () => refresh(),
            onError: (e) => alert("삭제에 실패했습니다.")
        });
    };

    return (
        <div className={styles.container}>
            <ListToolbar
                search={search}
                onSearchChange={setSearch}
                typeFilter={typeFilter}
                onTypeChange={setTypeFilter}
                typeOptions={publicationTypes}
                dateFrom={dateFrom}
                onDateFromChange={setDateFrom}
                dateTo={dateTo}
                onDateToChange={setDateTo}
            />

            <table className={styles.table}>
                <thead>
                    <tr>
                        <th>이름</th>
                        <th>이메일</th>
                        <th>출판유형</th>
                        <th>제출일</th>
                        <th>작업</th>
                    </tr>
                </thead>
                <tbody>
                    {filtered.length > 0 ? filtered.map((consult, index) => (
                        <tr key={index}>
                            <td>{consult.name}</td>
                            <td>{consult.email}</td>
                            <td>{consult.publicationType}</td>
                            <td>{formatDateString(consult.dateCreated)}</td>
                            <td>
                                <button
                                    onClick={() =>
                                        onItemClickHandle(consult)
                                    }
                                    className={styles.viewButton}
                                >
                                    상세보기
                                </button>
                                <button
                                    onClick={() => handleDelete(consult.consultationId)}
                                    className={styles.deleteButton}
                                >
                                    삭제
                                </button>
                            </td>
                        </tr>
                    )) : (
                        <tr>
                            <td colSpan={5} className={styles.empty}>검색 결과가 없습니다.</td>
                        </tr>
                    )}
                </tbody>
            </table>
            <div className={styles.pagination}>
                <Pagination page={page} totalPages={totalPages} onPageChange={setPage} />
            </div>
        </div>
    );
}

export default ConsultationList;